import EventsMixin from '../../../mixins/events'
export default {
  name: 're-modal',
  mixins: [EventsMixin],
  events: 'modal',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: null
    },
    noCloseButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    keyUp(event) {
      if (event.keyCode === 27) {
        this.close();
      }
    }
  },
  created: function() {
    document.addEventListener('keyup', this.keyUp);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.keyUp);
  }
}
